import { Component, OnChanges, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IonItemSliding } from '@ionic/angular';

import { Subscription } from 'rxjs';

import { PlacePanel } from '@unpispas/upp-base';
import { PriceType } from '@unpispas/upp-defs';

import { alertService } from '@unpispas/upp-base';
import { languageService } from '@unpispas/upp-base';
import { i18nSupport } from '@unpispas/upp-data';
import { dataService } from '@unpispas/upp-data';
import { ViewRenderer } from '@unpispas/upp-wdgt';
import { viewService } from '@unpispas/upp-base';

import { TicketView } from '@unpispas/upp-data';
import { ExtraView } from '@unpispas/upp-data';
import { TicketExtraView } from '@unpispas/upp-data';

/****************************/
/* TICKET EXTRA DISPLAY     */
/****************************/

class TicketExtraDisplay {
    constructor(private ticketextra: TicketExtraView, private _i18n: i18nSupport){
        // nothing to do
    }

    private get extra(): ExtraView | null {
        return this.ticketextra.extra;
    }

    /* access to calculated values */

    get ticket(): TicketView | null {
        return this.ticketextra.ticket;
    }

    get photo() : string | null {
        return (this.extra?.photo) || null;
    }

    get avatar() : string | null {
        return (this.extra?.avatar) || null;
    }

    get status(): string | null {
        return this.ticketextra.status;
    }

    get name(): string | null {
        return this._i18n.tr(this.extra?.name ?? null);
    }

    get description(): string | null {
        return this._i18n.tr(this.extra?.description ?? null);
    }

    get type(): string | null {
        return (this.extra?.type) || null;
    }

    get chargeinfo(): PriceType | null {
        return this.ticketextra.chargeinfo;
    }
}

/****************************/
/* UPP-EXTRA-TICKET         */
/****************************/

@Component({
    selector: 'upp-extra-ticket',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-ticket.html',
    styleUrls: [
      './upp-ticket.scss'
    ],
    providers: [{
        provide: ViewRenderer,
        useFactory: (change: ChangeDetectorRef) => new ViewRenderer(change),
        deps: [ChangeDetectorRef]
    }]       
})
export class UppExtraTicketComponent extends i18nSupport implements OnChanges, OnDestroy {
    @Input() extra: TicketExtraView | null = null;          // applied extra instance
    @Input() mode: 'EDIT' | 'VIEW' = 'VIEW';                // edition mode (from ticket panel)

    @Output() ToPanel = new EventEmitter<PlacePanel>();
    @Output() Updated = new EventEmitter<void>();

    private _extra_subscription: Subscription | null = null;

    constructor(private lang: languageService, private change: ViewRenderer, private alertCtrl: alertService, private data: dataService, public view: viewService){
        super(lang, change.cdref);
    }    

    ngOnChanges(){
        if (this._extra_subscription){
            this._extra_subscription.unsubscribe();
            this._extra_subscription = null;
        }

        if (this.extra){
            this._extra_subscription = this.extra.OnViewRefresh.subscribe(
            () => {
                if (this.display){
                    this.change.markForCheck();
                }
            });
        }
    }

    ngOnDestroy(): void {
        super.OnDestroy();

        if (this._extra_subscription){
            this._extra_subscription.unsubscribe();
            this._extra_subscription = null;
        }
    }   
    
    /********************************/
    /* DISPLAY OPTIONS              */
    /********************************/    
    
    private _display: TicketExtraDisplay | null = null; 
    get display() : TicketExtraDisplay | null {    
        if (this._display === null){
            if (this.extra != null){
                this._display = new TicketExtraDisplay(this.extra, this);
            }
        }

        return this._display;
    }


    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/

    private _onaction = false;
    get IsSliding(){
        return this._onaction;
    }

    IncludeExtra(event: Event, slider: IonItemSliding): void {
        event.stopPropagation();

        this._onaction = true;
        if (this.extra){
            this.extra.status = 'AC';
        }

        slider.close();
        setTimeout(() => {
            this._onaction = false;
            this.change.markForCheck();
        }, 600)

        this.Updated.emit();
    }

    RemoveExtra(event: Event, slider: IonItemSliding): void {
        event.stopPropagation();

        this._onaction = true;
        if (this.extra){
            this.extra.status = 'UN';
        }

        slider.close();
        setTimeout(() => {
            this._onaction = false;
            this.change.markForCheck();
        }, 600)

        this.Updated.emit();
    }
}